export default __webpack_public_path__ + "static/event5-5c67b420509101c165b11b7cd5d64b85.jpg";